export enum CreatePositionStepsEnums {
  LetsBegin = 'LETS_BEGIN',
  Experience = 'EXPERIENCE',
  Background = 'BACKGROUND',
  Education = 'EDUCATION',
  JobDescription = 'JOB_DESCRIPTION',
}
